import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toggle", "panel"]

  toggle() {
    const expanded = this.toggleTarget.getAttribute("aria-expanded") !== "true"
    this.toggleTarget.setAttribute("aria-expanded", String(expanded))
    this.panelTarget.setAttribute("aria-hidden", String(!expanded))
    this.panelTarget.inert = !expanded
    this.panelTarget.classList.toggle("grid-rows-[0fr]", !expanded)
    this.panelTarget.classList.toggle("grid-rows-[1fr]", expanded)
  }
}
